let titlesQuestions = document.querySelectorAll(".block_question_arrow");
for (let titleQuestion of titlesQuestions) {
  titleQuestion.addEventListener("click", function () {
    titleQuestion.nextElementSibling.classList.toggle("open");
    let titleArrow = titleQuestion.querySelector(".arrow_question");
    titleArrow.classList.toggle("arrow_rotate");
  });
}
